export default "/assets/images/icon-love.svg?5f607ec28070ba2f8eac2bb986a8494e";